import { IDENTIFIER_TYPE } from 'src/features/membership/types';

export enum IDENTIFIER_VALIDITY {
    FOREVER = 'forever',
    ONE_TIME = 'one_time',
    TIME_SENSITIVE = 'time_sensitive',
}

export type Identifier = {
    id: string;
    created_at: string;
    modified_at: string;
    type: IDENTIFIER_TYPE;
    value: string;
    validity: IDENTIFIER_VALIDITY;
    is_used: boolean | null;
    valid_from: string | null;
    valid_to: string | null;
    attributes: any;
};
